import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';
import { GiftSpecialOffer, SingleSpecialOffer } from '@telialt/models/src/EshopModel';

const SINGLE_MODAL_ID = 'special-offer-single-modal';
export const useSpecialOfferSingleModalControls = () => useBrowserModalControls<SingleSpecialOffer>(SINGLE_MODAL_ID);

const GIFT_MODAL_ID = 'special-offer-gift-modal';
export const useSpecialOfferGiftModalControls = () => useBrowserModalControls<GiftSpecialOffer>(GIFT_MODAL_ID);
